export default {
	"copy" : "Copy",
	"dnd" : "Drop Files Here",
	"remove" : "Remove",
	"save" : "Save",
	"confirm":"The card will be deleted permanently, are you sure?",
	"editor":{
		"add" : "Add card",
		"assign" : "Assign to",
		"attachments" : "Attachments",
		"color" : "Color",
		"edit" : "Edit card",
		"status" : "Status",
		"tags" : "Tags",
		"text" : "Text",
		"upload" : "Upload"
	},
	"menu":{
		"copy": "Copy",
		"edit": "Edit",
		"remove": "Remove"
	}
};